// Copyright (c) Docugami, Inc. All rights reserved.

import { IReportRow } from 'components/reports/AgGridReportTable';
import React, { MutableRefObject } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColumnMovedEvent, GridOptions } from 'ag-grid-community';
import "ag-grid-community/styles/ag-grid.css";
import { AgGridContainerStyle, AgGridLibraryStyleAlterations } from './AgGridGridStyling';


// Use the following code to use actual ag-grid type once we start https://classifyprocess.visualstudio.com/product/_workitems/edit/20723
// export type AGGridGridCellRendererProps = CustomCellRendererProps<IReportRow>;
export type AGGridGridCellRendererProps = any;
export type AgGridGridColumns = GridOptions<IReportRow>['columnDefs'];

type AgGridGridProps = {
    gridRef: MutableRefObject<AgGridReact<IReportRow>>;
    columns: AgGridGridColumns;
    items: IReportRow[];
    onColumnMoved?: (e: ColumnMovedEvent<IReportRow>) => void;
}

const getRowId = (folderId: string, fileName: string): string => {
    return `${folderId}-${fileName}`;
};

const AgGridGrid: React.FC<AgGridGridProps> = (props) => {
    return (
        <>
            <AgGridLibraryStyleAlterations />
            <div style={AgGridContainerStyle}>
                <AgGridReact
                    ref={props.gridRef}
                    rowData={props.items}
                    columnDefs={props.columns}
                    getRowId={(params) => getRowId(params.data.folderId, params.data.fileName)}
                    rowHeight={300}
                    headerHeight={120}
                    groupHeaderHeight={20}
                    suppressColumnVirtualisation={true}
                    rowBuffer={3}
                    suppressRowHoverHighlight
                    suppressScrollOnNewData
                    suppressDragLeaveHidesColumns
                    onColumnMoved={props.onColumnMoved}
                />
            </div>
        </>
    );
}

export default AgGridGrid;
